import React from "react";

export const useStartRecordingCm = (
  isRecordingCm,
  localRef,
  cmMediaRecorderRef,
  cmChunksRef,
  setIsRecordingCm,
  handleLogs,
) => {
  const startRecordingCm = React.useCallback(() => {
    if (!localRef.current || !localRef.current.srcObject) return;
    if (isRecordingCm) return;

    try {
      const stream = localRef.current.srcObject;
      const getSupportedMimeType = () => {
        const types = [
          "video/webm;codecs=vp9,opus",
          "video/webm;codecs=vp8,opus",
          "video/webm",
          "video/mp4;codecs=h264,mp4a.40.2",
          "video/mp4",
        ];
        return types.find((type) => MediaRecorder.isTypeSupported(type)) || "";
      };

      const options = { mimeType: getSupportedMimeType() };
      cmMediaRecorderRef.current = new MediaRecorder(stream, options);

      cmMediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          cmChunksRef.current.push(event.data);
        }
      };

      cmMediaRecorderRef.current.start();
      setIsRecordingCm(true);
      handleLogs("CM Recording started (Local stream)");
    } catch (error) {
      console.error("Error starting CM recording:", error);
      handleLogs("Error starting CM recording: " + error.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLogs, isRecordingCm]);
  return { startRecordingCm };
};
